import { ConfirmDialog } from "../../ui";

type ConfirmAllTeamMembersDialogProps = {
  teamName: string;
  memberCount: number;
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const ConfirmAllTeamMembersDialog = (props: ConfirmAllTeamMembersDialogProps) => (
  <ConfirmDialog
    open={props.isOpen}
    onClose={() => props.onClose()}
    // Awaited as before: the dialog stays busy while it runs, closes when it resolves and stays open if it throws.
    onConfirm={async () => {
      try {
        await props.onConfirm();
      } catch (error) {
        console.error(error);
        throw error;
      }
    }}
    tone="primary"
    title="Confirm All Team Members?"
    message={
      <>
        <p>
          Are you sure you want to confirm all <strong>{props.memberCount}</strong> members of team{" "}
          <strong>"{props.teamName}"</strong>?
        </p>
        <p>This action will set all team members' status to "Confirmed".</p>
      </>
    }
    confirmLabel="Confirm All"
  />
);

export default ConfirmAllTeamMembersDialog;
